'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('transition', {
      attrs: {
        "name": "suspend-menu"
      }
    }, [_vm.show ? _c('div', {
      staticClass: "suspend-menu"
    }, [_c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "suspend-menu-mask",
      on: {
        "touchmove": function touchmove($event) {
          $event.preventDefault();
        },
        "click": function click($event) {
          _vm.$emit('clickMask');
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "suspend-menu-box",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._t("default")], 2)]) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'suspend-menu',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
});

exports.default = index;
